import React, { useMemo, memo } from 'react';
import { InstantSearch as InstantSearchAlgoliaComponent } from 'react-instantsearch';
import createInstantSearchRouterNextUtil from '@/utilites/algolia/create-instant-router-next';
import searchClient from './searchClient';
import { InstantSearchAlgoliaProps } from '@/types/other';
import envPublic from '@/config/env.public';

const InstantSearch = InstantSearchAlgoliaComponent as any;

const InstantSearchAlgolia = ({
  children,
  serverUrl,
  extraProps,
  isSkusPage,
  customBaseUrl,
  curationSelectionHighlightSlug,
}: InstantSearchAlgoliaProps) => {
  const instantRouterNext = useMemo(() => {
    if (isSkusPage) {
      return createInstantSearchRouterNextUtil(
        serverUrl,
        customBaseUrl,
        curationSelectionHighlightSlug
      );
    }
    return null;
  }, [serverUrl, isSkusPage, customBaseUrl, curationSelectionHighlightSlug]);

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={envPublic.NEXT_PUBLIC_ALGOLIA_INDEX}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      routing={
        instantRouterNext
          ? {
              router: instantRouterNext,
            }
          : false
      }
      {...extraProps}
    >
      {children}
    </InstantSearch>
  );
};

export default memo(InstantSearchAlgolia);
